import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Chats } from '@/features/chats'
import { requireActiveSubscription } from '@/lib/middleware'

const searchSchema = z.object({
  conversationId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/chats/')({
  beforeLoad: async () => requireActiveSubscription(),
  component: Chats,
  validateSearch: searchSchema,
})
